/* eslint-disable */
export function userRoles(state) {
  return state.userinfo.roleids;
}

export function userInfo(state) {
  return state.userinfo;
}

export function imUrl(state) {
  return state.im_url;
}

export function local() {
  return state.local;
}
